import { defineNuxtPlugin } from '#app';
import * as base64 from './dsc/base64.mjs';
import * as filters from './dsc/filters.mjs';
import * as object from './dsc/object.mjs';
import * as http from './dsc/http.mjs';
import localeMethods from './dsc/locale.mjs';
import msg from './dsc/messages.mjs';

export default defineNuxtPlugin(nuxtApp => ({
    provide: {
        dsc: {
            base64,
            filters,
            object,
            http,
            locale: localeMethods(nuxtApp),
            msg: msg(nuxtApp),
            delay: timeout => new Promise(resolve => setTimeout(resolve, timeout)),
            uuidv4: () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
                /[xy]/g,
                c => {
                    const radix = 16;
                    const r = Math.random() * radix | 0, v = c === 'x' ? r : (r & 0x3 | 0x8); // eslint-disable-line no-magic-numbers

                    return v.toString(radix);
                }),
            async windowScrollTo(arg = { top: 0 }) {
                // This delay fixes an issue with Firefox and smooth scrolling.
                await nuxtApp.$dsc.delay(0);
                window?.scrollTo?.(arg);
            },
            production: process.env.NODE_ENV === 'production',
            /**
             * @param {*} value A value to check whether it is primitive or not
             * @returns {boolean}
             */
            isPrimitive: value => Object(value) !== value,
        },
    },
}));

